const MuiPickersModal = {
    dialogAction: {
        color: 'red',
    },
}

export default MuiPickersModal;
